import UserService from "Api/Services/UserService";
import React, { useEffect, useState } from "react";
import { Col, Card, CardBody } from "reactstrap";

//Simple bar
import SimpleBar from "simplebar-react";

const Notifications = () => {
    const [notificationsData, setNotificationsData] = useState([]);
    const imageUrl = process.env.REACT_APP_PROFILE_IMAGE_API_URL;
    const [error, setError] = useState('');

    const getNotificationList = async () => {
        try {
            let response = await UserService.AllNotificationList().json();
             
            if (response.status) {
                setNotificationsData(response.data);
                return;
            } else {
                setError(response.message);
                return;
            }

        } catch (error) {
            setError('something went wrong');
            return;
        }
    };

    useEffect(() => {
        getNotificationList();
    },[]);
    return (
        <React.Fragment>
            <Col xl="12" className="mt-5 pt-3 mb-5" >
                <Card>
                    <CardBody>
                        <SimpleBar>
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Notifications </h4>
                            </div>
                            <ul className="list-group "> 
                                {(notificationsData || []).map((item, index) => (
                                    <li className="list-group-item border-0 commonboxform mb-3  ms-1 me-1" key={index}>
                                        <div className="d-flex">
                                            <div className="flex-shrink-0 me-3">
                                                <div className="avatar-xs">
                                                    <span className="avatar-title rounded-circle bg-light">
                                                        <img src={imageUrl + '/' + item.user_image} alt="" height="18" />
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h5 className="font-size-14">{item.username ? item.username : item.sent_by_name}</h5>
                                                <p className="text-muted">{item.content}</p>

                                                {/* <div className="float-end">
                                                    <p className="text-muted mb-0">
                                                        <i className="mdi mdi-account me-1" /> {item.sent_by_name}
                                                    </p>
                                                </div> */}
                                                <p className="text-muted mb-0">{item.sent_at}</p>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </SimpleBar>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default Notifications;
